import { parseEndOfDayFromQueryParam } from '@helpers/parseEndOfDayFromQueryParam';
import { parseMeetingTypesFromQueryParam } from '@helpers/parseMeetingTypesFromQueryParam';
import { parseMinutesFromQueryParam } from '@helpers/parseMinutesFromQueryParam';
import { parseStartOfDayFromQueryParam } from '@helpers/parseStartOfDayFromQueryParam';
import { parseStatusesFromQueryParam } from '@helpers/parseStatusesFromQueryParam';
import { TParsedJobsFilters } from 'app/types/TParsedJobsFilters';

export const parseJobsFiltersFromSearchParams = (searchParams: URLSearchParams): TParsedJobsFilters => {
  const asOneFilter = searchParams.get('asOne') === 'true';

  return {
    jobsFilter: {
      from: parseStartOfDayFromQueryParam(searchParams.get('from')),
      to: parseEndOfDayFromQueryParam(searchParams.get('to')),
    },
    statusFilter: parseStatusesFromQueryParam(searchParams.get('statuses')),
    asOneFilter,
    postFilter: !asOneFilter && searchParams.get('post') === 'true',
    meetingTypeFilter: asOneFilter ? parseMeetingTypesFromQueryParam(searchParams.get('meetingTypes')) : [],
    durationFilter: {
      fromMinutes: parseMinutesFromQueryParam(searchParams.get('durationFrom')),
      toMinutes: parseMinutesFromQueryParam(searchParams.get('durationTo')),
    },
  };
};
